import Translator from 'bazinga-translator'
import locale from 'date-fns/locale/cs'

import { initCurrentLocale } from '../utils/dates'
import translations from './cs.json'

Translator.fromJSON(translations as unknown as string)
initCurrentLocale(locale)
